module.exports = __webpack_public_path__ + "static/media/iChlor.9c73b041.pdf";